import React from 'react';
import camelcase from 'camelcase-es5';

import InputLabel from '../InputLabel';

import TextFieldFormControl from './TextFieldFormControl';
import TextFieldInput from './TextFieldInput';
import TextFieldFooter from './TextFieldFooter';
import TextFieldBase from './TextFieldBase';
import TextFieldPrefix from './TextFieldPrefix';
import useFormControlReducer from '../../hooks/useFormControlReducer';
import TLicensePlateTextField from './@types/LicensePlateTextField';
import generateTextFieldIds, { isCharsExceeded } from './generateTextFieldIds';
import Asset from '../Asset';

const LicensePlateTextField = ({
  errorText,
  helperText,
  optionalText,
  inputRef,
  isRequired,
  labelText = '',
  charsRemainingText,
  charsExceededText,
  onChange,
  onFocus,
  onBlur,
  onMouseOut,
  onMouseOver,
  onKeyPress,
  autoFocus,
  value,
  countryCode,
  maxLength = 10,
  locale,
  id = `LicensePlateTextField-${camelcase(labelText)}`,
  dataTestId,
  ariaLabel,
}: TLicensePlateTextField) => {
  const { state, handlers } = useFormControlReducer({
    onChange,
    onFocus,
    onBlur,
    onMouseOut,
    onMouseOver,
    errorText,
    value,
  });

  const { isEmpty, isErrored, isFocused, characterCount } = state;
  const { handleChange, handleFocus, handleBlur, handleMouseOver, handleMouseOut } = handlers;

  const charsExceeded = isCharsExceeded(characterCount, maxLength);
  const { helperTextId, errorTextId, charsExceededId } = generateTextFieldIds(id, Boolean(errorText), charsExceeded);
  return (
    <TextFieldBase kind="licensePlate">
      {labelText && (
        <InputLabel htmlFor={id} isInputRequired={isRequired} labelText={labelText} optionalText={optionalText} />
      )}

      <TextFieldFormControl isFocused={isFocused} isErrored={isErrored} isEmpty={isEmpty}>
        <TextFieldPrefix>
          <Asset.Square name="eu-license-plate-icon" locale={locale} />
          <div className="hz-CountrySpec">{countryCode}</div>
        </TextFieldPrefix>

        <TextFieldInput
          id={id}
          ref={inputRef}
          isRequired={isRequired}
          value={value}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onMouseOver={handleMouseOver}
          onMouseOut={handleMouseOut}
          onKeyPress={onKeyPress}
          autoFocus={autoFocus}
          data-testid={dataTestId}
          ariaLabel={ariaLabel}
          helperTextId={helperTextId}
          errorTextId={errorTextId}
          charsExceededId={charsExceededId}
          maxLength={maxLength}
        />
      </TextFieldFormControl>
      <TextFieldFooter
        helperText={helperText}
        errorText={errorText}
        charsRemainingText={charsRemainingText}
        charsExceededText={charsExceededText}
        characterCount={characterCount}
        id={helperTextId}
        errorTextId={errorTextId}
        charsExceededId={charsExceededId}
        charsExceeded={charsExceeded}
      />
    </TextFieldBase>
  );
};

export default LicensePlateTextField;
